import { convertToLocale } from "@lib/util/money"
import { HttpTypes } from "@medusajs/types"
import { PRICE_ANIMATION_SETTINGS } from "@lib/animations/price-animation-settings"

type LineItemPriceProps = {
  item: HttpTypes.StoreCartLineItem | HttpTypes.StoreOrderLineItem
  style?: "default" | "tight"
  currencyCode: string
  showComparePrice?: boolean
  animatedComparePrice?: boolean
}

const LineItemPrice = ({
  item,
  style = "default",
  currencyCode,
  showComparePrice = true,
  animatedComparePrice = false,
}: LineItemPriceProps) => {
  const { total, original_total } = item

  const originalPrice = original_total ?? 0
  const currentPrice = total ?? 0

  const hasReducedPrice =
    showComparePrice && originalPrice > 0 && currentPrice < originalPrice



  if (hasReducedPrice && animatedComparePrice && PRICE_ANIMATION_SETTINGS.enabled) {
  return (
    <div
  className="relative inline-flex"
  style={
  {
    "--price-cycle": `${PRICE_ANIMATION_SETTINGS.cycleDuration}s`,
    "--price-old-appear": `${PRICE_ANIMATION_SETTINGS.oldPriceAppear}s`,
  } as React.CSSProperties
}

>
      <span
        className="
          absolute inset-0 z-[2]
          inline-flex min-w-[72px] items-center justify-center
          px-2 py-[3px]
          rounded-full
          text-white
          text-[15px]
          font-bold
          tracking-tight
          shadow-[0_3px_6px_rgba(0,0,0,0.35),inset_0_1px_0_rgba(255,255,255,0.25)]
          border border-black/20
          whitespace-nowrap
          animate-priceOldPill
        "
        style={{
          background: "linear-gradient(180deg,#284469 0%,#17365b 100%)",
        }}
        data-testid="product-original-price"
      >
        <span className="line-through text-white/85">
          {convertToLocale({
            amount: originalPrice,
            currency_code: currencyCode,
          })}
        </span>
      </span>

      <span
        className="
          relative z-[1]
          inline-flex min-w-[72px] items-center justify-center
          px-2 py-[3px]
          rounded-full
          bg-gradient-to-b from-orange-500 to-orange-600
          ring-1 ring-orange-700
          text-white
          text-[15px]
          font-bold
          tracking-tight
          shadow-[0_3px_6px_rgba(0,0,0,0.35),inset_0_1px_0_rgba(255,255,255,0.25)]
          border border-black/20
          whitespace-nowrap
          animate-priceNewPill
        "
        data-testid="product-price"
      >
        {convertToLocale({
          amount: currentPrice,
          currency_code: currencyCode,
        })}
      </span>
    </div>
  )
}



  return (
    <div className="flex flex-col items-end">
      {hasReducedPrice && PRICE_ANIMATION_SETTINGS.enabled && (
        <p className="mb-[2px]">
          <span
            className="line-through text-black/40 text-[12px]"
            data-testid="product-original-price"
          >
            {convertToLocale({
              amount: originalPrice,
              currency_code: currencyCode,
            })}
          </span>
        </p>
      )}

      <span
        className="
          inline-flex min-w-[72px] items-center justify-center
          px-2 py-[3px]
          rounded-full
          bg-gradient-to-b from-orange-500 to-orange-600
          ring-1 ring-orange-700
          text-white
          text-[15px]
          font-bold
          tracking-tight
          shadow-[0_3px_6px_rgba(0,0,0,0.35),inset_0_1px_0_rgba(255,255,255,0.25)]
          border border-black/20
        "
        data-testid="product-price"
      >
        {convertToLocale({
          amount: currentPrice,
          currency_code: currencyCode,
        })}
      </span>
    </div>
  )
}

export default LineItemPrice
